import {
  REQUEST_CP,
  RECEIVE_CP,
  CP_FAILED,
  RECEIVE_SPCP,
  REQUEST_SPCP,
  SPCP_FAILED
} from '../actions/types';

export const creativeProductsRequest = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_CP:
      return Object.assign({}, state, {
        isFetching: false,
        creativeproducts: action.creativeproducts
      });
    case REQUEST_CP:
      return Object.assign({}, state, {
        isFetching: true,
        creativeproducts: []
      });
    case CP_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        creativeproducts: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export const creativeProductsLookup = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_SPCP:
      return Object.assign({}, state, {
        isFetching: false,
        creativeproducts: action.creativeproducts
      });
    case REQUEST_SPCP:
      return Object.assign({}, state, {
        isFetching: true,
        creativeproducts: []
      });
    case SPCP_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        creativeproducts: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}
